import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  InputAdornment,
  Paper,
  Divider,
  Box,
  IconButton,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import * as yup from "yup";
import { useFormik } from "formik";
import { connect } from "react-redux";
import {
  START_RESET_PASSWORD,
  RESET_STATE,
  START_VERIFY_RESET_PASSWORD_LINK,
} from "Actions/AuthAction";
import { useNotification } from "Hooks/NotificationManager";
import Button from "Components/Common/Button/Button";
import "../../Sass/Auth.scss";
import regex from "constants/regex";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import Reset from "Assets/Image/reset_password.svg";
import logo from "Assets/Logo/RepeatSmart.svg";

const useStyle = makeStyles((theme) => ({
  rsButton: {
    textAlign: "center",
    marginTop: "30px !important",
    "&>button": {
      color: "#ffffff",
      fontSize: "18px",
      minWidth: "160px",
      minHeight: "50px",
      fontWeight: "bold",
      backgroundColor: " #3cb477",
      borderRadius: "8px",
      border: "none",
      boxShadow: "0px 7px #309562",
      padding: "0px 30px",
      display: "inline-flex",
      alignItems: " center",
      justifyContent: " center",
      "&:hover,&:active,&:focus-visible": {
        backgroundColor: "#2A7E54 !important",
        boxShadow: "0px 7px #309562",
      },
    },
  },
  rsPassword: {
    "&>svg": {
      height: "23px",
      width: "23px",
    },
  },
}));

const ResetPassword = (props) => {
  const {
    dispatchResetPassword,
    resetPasswordDetail,
    dispatchResetState,
    dispatchVerifyResetPasswordLink,
    verifyRestPasswordLink,
  } = props;
  const classes = useStyle();
  const navigate = useNavigate();
  const notification = useNotification();
  const params = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [isResetPasswordProceed, setIsResetPasswordProceed] = useState(false);

  const handleResetPassword = (data) => {
    setIsResetPasswordProceed(true);
    dispatchResetPassword({ password: data.password, token: params?.token });
  };

  /* Reset PAssword Schema */
  const resetPasswordSchema = yup.object().shape({
    password: yup
      .string("Must be string")
      .required("Password is required field.")
      .min(8, "Password length should be atleast 8 characters.")
      .matches(
        /^(?=.*[a-z])/,
        "password must contain at least 1 lower case letter"
      )
      .matches(
        /^(?=.*[A-Z])/,
        "password must contain at least 1 upper case letter"
      )
      .matches(/^(?=.*[0-9])/, "password must contain at least 1 number")
      .matches(
        regex.password,
        "password must contain at least 1 special character"
      ),
    confirm_password: yup
      .string("Must be string")
      .required("Confirm Password is required field.")
      .matches(
        /^(?=.*[a-z])/,
        "Confirm password must contain at least 1 lower case letter"
      )
      .matches(
        /^(?=.*[A-Z])/,
        "Confirm password must contain at least 1 upper case letter"
      )
      .matches(
        regex.password,
        "Confirm password must contain at least 1 number"
      )
      .matches(
        /^(?=.*[0-9])/,
        "Confirm password must contain at least 1 special character"
      )
      .oneOf(
        [yup.ref("password"), null],
        "Confirm password should be same as password"
      ),
  });

  /* Fromik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setFieldError,
    handleBlur,
  } = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: handleResetPassword,
    enableReinitialize: true,
  });

  /* Send Link useffect for reset password */
  useEffect(() => {
    dispatchVerifyResetPasswordLink(params.token);
  }, []);

  /* Reset Password Success  */
  useEffect(() => {
    if (verifyRestPasswordLink.success === false) {
      notification.error("The given link is invalid or link has been expired");
      navigate("/login");
    }
  }, [verifyRestPasswordLink.success]);

  /* Loading UseEffect  */
  useEffect(() => {
    if (isResetPasswordProceed) {
      if (!resetPasswordDetail.success) {
        if (resetPasswordDetail.errors) {
          const errorPresent =
            Object.keys(resetPasswordDetail.errors).length > 0;
          if (errorPresent > 0) {
            Object.keys(resetPasswordDetail.errors).forEach(function (key) {
              setFieldError(key, resetPasswordDetail.errors[key][0]);
            });
          }
        }
      } else {
        notification.success("Password has been updated successfully.");
        resetForm();
        dispatchResetState("resetPasswordDetail", "");
        navigate("/home");
      }
      setIsResetPasswordProceed(false);
    }
  }, [resetPasswordDetail.success, resetPasswordDetail.errors]);

  return (
    <Paper className="rs_Resetpassword">
      <Box className="rs_ResetHeight">
        <div elevation={0} className="rsBoxsubroot">
          <div className="rsResetLogo">
            <img src={logo} alt="" width="340px" />
          </div>
          <img src={Reset} alt="" width="50" />
          <Typography variant="h2" semiBold style={{ color: "#000" }}>
            Reset Password
          </Typography>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="rsForm"
          >
            <TextField
              className="RsInput"
              secondary
              fullWidth
              name="password"
              placeholder="New Password"
              autoComplete="password"
              autoFocus
              type={showPassword ? "text" : "password"}
              value={values.password}
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              InputProps={{
                startAdornment: (
                  <>
                    {/* <InputAdornment position="start">
                      <PrimaryIcon width="20px" icon={LockIcon} />
                    </InputAdornment>
                    <Divider className="rsInputDivider" /> */}
                  </>
                ),
                endAdornment: (
                  <>
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        className={classes.rsPassword}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <VisibilityOutlinedIcon />
                        ) : (
                          <VisibilityOffOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              }}
              error={touched.password && errors.password}
              helperText={touched.password && errors.password}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              className="RsInput"
              secondary
              fullWidth
              name="confirm_password"
              type={showCPassword ? "text" : "password"}
              placeholder="Confirm Password"
              autoComplete="confirm_password"
              value={values.confirm_password}
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              InputProps={{
                startAdornment: (
                  <>
                    {/* <InputAdornment position="start">
                      <PrimaryIcon width="20px" icon={LockIcon} />
                    </InputAdornment>
                    <Divider className="rsInputDivider" /> */}
                  </>
                ),
                endAdornment: (
                  <>
                    <InputAdornment position="start">
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={() => setShowCPassword(!showCPassword)}
                        className={classes.rsPassword}
                      >
                        {showCPassword ? (
                          <VisibilityOutlinedIcon />
                        ) : (
                          <VisibilityOffOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              }}
              error={touched.confirm_password && errors.confirm_password}
              helperText={touched.confirm_password && errors.confirm_password}
              InputLabelProps={{ shrink: true }}
            />
            <Box className={classes.rsButton}>
              <Button
                children="Submit"
                variant="contained"
                color="primary"
                disabled={
                  resetPasswordDetail?.isLoading ||
                  verifyRestPasswordLink.isLoading
                }
                loading={resetPasswordDetail?.isLoading}
                type="submit"
              />
            </Box>
          </form>
        </div>
      </Box>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  resetPasswordDetail: state.auth.resetPasswordDetail,
  verifyRestPasswordLink: state.auth.verifyRestPasswordLink,
});
const mapDispatchToProps = (dispatch) => ({
  dispatchResetPassword: (data, token) =>
    dispatch({ type: START_RESET_PASSWORD, data, token }),
  dispatchResetState: (key, payload) =>
    dispatch({ type: RESET_STATE, key, payload }),
  dispatchVerifyResetPasswordLink: (token) =>
    dispatch({ type: START_VERIFY_RESET_PASSWORD_LINK, token }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
